import CustomAccordionListElement from "./CustomAccordionListElement";

const CustomAccordionDetails = ({ accordionItem }) => {
  return (
    <div className="w-full bg-white p-2">
      <div className="border-l-4 border-gray-100">
        {accordionItem &&
          accordionItem.map((accordionElement, index) => (
            <CustomAccordionListElement accordionElement={accordionElement} key={index} />
          ))}
      </div>
    </div>
  );
};

export default CustomAccordionDetails;
